import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { x } from '@xstyled/styled-components';
import { useTranslation } from 'react-i18next';
import { SectionTitle } from '../text/section-title';
import { When } from '../utils/when';
import { TextArea } from '../form/textarea';
import { colors } from '../theme/colors';
import { ButtonPrimary } from '../buttons/primary';
import { LoadingDot } from '../loading-dot';
import RatingSelection from './rating-selection';
export function RatingForm(props) {
  var _props$commentary;

  var _useState = useState(props.rating),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = useState((_props$commentary = props.commentary) !== null && _props$commentary !== void 0 ? _props$commentary : ''),
      commentary = _useState2[0],
      setCommentary = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var placeholder = value < 3 ? t('TELL_ABOUT_YOUR_EXPERIENCE') : t('TELL_MORE_IF_YOU_WANT');
  var disabled = !value || props.disableSubmit;

  var handleSubmit = function handleSubmit(ev) {
    ev.preventDefault();
    if (!disabled) props.onSubmit({
      rating: value,
      commentary: commentary
    });
  };

  return /*#__PURE__*/_jsxs(x.form, {
    w: "100%",
    maxWidth: "lg",
    onSubmit: handleSubmit,
    children: [/*#__PURE__*/_jsx(x.div, {
      pb: "32px",
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: props.title ? props.title : t('RATE_YOUR_EXPERIENCE')
      })
    }), /*#__PURE__*/_jsx(x.p, {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "15px",
      lineHeight: "18px",
      color: colors.textForeground,
      children: props.description ? props.description : t('HOW_YOUR_EXPERIENCE')
    }), /*#__PURE__*/_jsx(RatingSelection, {
      value: value,
      setValue: setValue,
      formType: props.formType
    }), /*#__PURE__*/_jsx(When, {
      value: !!value && props.enableCommentary,
      children: /*#__PURE__*/_jsx(x.div, {
        w: "100%",
        mt: "32px",
        children: /*#__PURE__*/_jsx(TextArea, {
          id: "rating-textarea",
          name: "rating-textarea",
          placeholder: placeholder,
          value: commentary,
          label: t('COMMENT'),
          onChange: function onChange(value) {
            return setCommentary(value);
          },
          maxWidth: "100%",
          rows: 3,
          maxLength: 1000
        })
      })
    }), /*#__PURE__*/_jsx(When, {
      value: !!value || props.showButton,
      children: /*#__PURE__*/_jsx(x.div, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        w: "100%",
        mt: "34px",
        children: /*#__PURE__*/_jsxs(ButtonPrimary, {
          "data-testid": "submit-rating-button",
          id: "trakr-whatsapp-confirm-btn",
          disabled: disabled,
          bgColor: colors.inputColor,
          type: "submit",
          children: [/*#__PURE__*/_jsx(When, {
            value: !props.disableSubmit,
            children: t('SEND_FEEDBACK')
          }), /*#__PURE__*/_jsx(When, {
            value: props.disableSubmit,
            children: /*#__PURE__*/_jsx(LoadingDot, {})
          })]
        })
      })
    })]
  });
}
RatingForm.defaultProps = {
  disableSubmit: false
};